const lengthChart = document.querySelector(".js_nails-length-chart"); 
const shapeChart = document.querySelector(".js_nails-shape-chart"); 
const mobileShapeNails = document.querySelector(".mobile-nail-shape--container ");
const mobileLengthNails = document.querySelector(".mobile-nail-length-carousel--container");
 

function toggleSizeAndShapeCharts(b) {
    let chart = b.getAttribute("data-chart"); 
    if (chart == "length") {
        lengthChart.classList.add("active-chart");
        shapeChart.classList.remove("active-chart");
        mobileLengthNails.classList.add("active-chart");  
        mobileShapeNails.classList.remove("active-chart");
    } else {
        lengthChart.classList.remove("active-chart"); 
        shapeChart.classList.add("active-chart");
        mobileLengthNails.classList.remove("active-chart"); 
        mobileShapeNails.classList.add("active-chart");
    }  
   
}

switchBtns.forEach(function(btn,i){
	btn.addEventListener('click', function(){
		toggleSizeAndShapeCharts(btn);
	})
});